
































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import Dropdown from '@/components/common/Dropdown.vue';
import List from '@/components/list/List.vue';
import ListItem from '@/components/list/ListItem.vue';

import AuthMixin from '@/mixins/auth';
import IdentityMixin from '@/mixins/identity';

@Component({
  components: { ListItem, List, Dropdown },
})
export default class PageHeaderUser extends mixins(AuthMixin, IdentityMixin) {
  get id() {
    if (!this.authUser) {
      return;
    }

    const { id, sub } = this.authUser;

    return id || sub;
  }

  get name() {
    if (!this.authUser) {
      return;
    }

    const { name, username } = this.authUser;

    return name || username;
  }

  get image() {
    return this.authUser && this.authUser.picture;
  }

  handleLogin() {
    this.$emit('login');
  }

  handleLogout() {
    this.$emit('logout');
  }
}
